module.exports = __webpack_public_path__ + "img/jieshao.39484448.png";